import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { AuthService } from 'app/core/auth/auth.service';
import { EncryptdecryptService } from 'app/shared/services/encryptdecrypt.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user'
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;
    encryptstring:string = "";
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _authService:AuthService,
        private EncrDecr: EncryptdecryptService,
        private oauthService:OAuthService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    name:string=""
    ngOnInit(): void
    {
        const claims = this.oauthService.getIdentityClaims();
         
                this.name = claims['name'];

        this.user = JSON.parse(this._authService.accessUser);

        //console.log("Check User :::--->", this._authService.accessUser);

        // alert("User Id --> " + this.user.id);
        // alert("company_id --> " + this.user.company_id);
        // alert("partner_id --> " + this.user.partner_id);

        // Subscribe to user changes
        // this._userService.user$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((user: User) => {
        //         this.user = user;

        //         //console.log("Check User :::--->", this.user);

        //         // Mark for check
        //         this._changeDetectorRef.markForCheck();
        //     });
    }
    activityLog(){
        this._router.navigate(['/activitylogreportuser/user']);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {
        // Return if user is not available
        if ( !this.user )
        {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void
    {
       
        this._router.navigate(['/sign-out']);
    }

    changepassword():void
    {
        
        this._router.navigate(['/change-password']);
    }

    userdetail(id: any): void {
        this.EncrDecr.getEncryptid(id).subscribe(
            (res: any) => {
          
            this.encryptstring = res.encryptedText;
            if(this.encryptstring !=null && this.encryptstring != '')
            {
                this._router.navigate(['/user/userdetail', this.encryptstring]);
            }
        })
    
        //let encodeID = this.EncrDecr.encryptUsingAES256(id);
       
      }

      
}
